<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">medical_services</span>
      <p>
        Consulta y gestiona las atenciones médicas del día: búsqueda por
        diferentes criterios, acceso al detalle, documentos y edición del
        formulario clínico.
      </p>
    </div>

    <!-- Búsquedas -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Búsqueda de atenciones
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in busquedas" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Estados -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Estados de una atención
      </h3>
      <div class="help-estados">
        <span
          v-for="e in estados"
          :key="e.label"
          class="help-estado-badge"
          :style="{ background: e.color, color: e.text }"
        >{{ e.label }}</span>
      </div>
    </section>

    <!-- Acciones por fila -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Opciones por atención
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>Al iniciar sesión se cargan automáticamente las atenciones del médico para el día de hoy. Usa los filtros para ampliar o precisar la búsqueda.</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaAtencion",
  data() {
    return {
      busquedas: [
        {
          icon: "pending_actions",
          titulo: "Atenciones de hoy",
          desc:   "Pulsa el botón de agenda para cargar automáticamente las atenciones del médico para el día actual.",
        },
        {
          icon: "filter_list",
          titulo: "Por estado",
          desc:   "Selecciona un estado del listado (PENDIENTE, PROCESO, FINALIZADA, PLANILLA GENERADA, FACTURADA) para filtrar las atenciones.",
        },
        {
          icon: "tag",
          titulo: "Por número",
          desc:   "Ingresa el número de atención y presiona Enter para acceder directamente al registro.",
        },
        {
          icon: "badge",
          titulo: "Por cédula",
          desc:   "Ingresa el número de cédula del paciente y presiona Enter para ver todas sus atenciones.",
        },
        {
          icon: "person_search",
          titulo: "Por nombre",
          desc:   "Escribe parte del nombre del paciente y presiona Enter para buscar sus atenciones.",
        },
      ],
      estados: [
        { label: "PENDIENTE",         color: "#fff3cd", text: "#856404" },
        { label: "PROCESO",           color: "#cce5ff", text: "#004085" },
        { label: "FINALIZADA",        color: "#d4edda", text: "#155724" },
        { label: "PLANILLA GENERADA", color: "#e2d9f3", text: "#4a235a" },
        { label: "FACTURADA",         color: "#d1ecf1", text: "#0c5460" },
      ],
      acciones: [
        {
          icon:  "summarize",
          color: "#0059cc",
          titulo: "Resumen",
          desc:   "Muestra un resumen rápido de la atención: paciente, médico, especialidad, fechas y estado actual.",
        },
        {
          icon:  "edit_note",
          color: "#198754",
          titulo: "Detalles",
          desc:   "Abre el formulario clínico completo de la atención para revisar o editar toda la información registrada.",
        },
        {
          icon:  "description",
          color: "#6f42c1",
          titulo: "Indicaciones",
          desc:   "Genera y descarga en PDF las indicaciones médicas emitidas en esta atención.",
        },
        {
          icon:  "verified",
          color: "#fd7e14",
          titulo: "Certificado",
          desc:   "Genera y descarga en PDF el certificado médico correspondiente a esta atención.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>